import { createStore } from 'redux'

const initialState = {
    user: {
        userId: 0,
        employeeId: 0,
        objectId: null,
        username: null,
        permissions: [],
        favourites: [],
    },
    isFavourites: false,
    isSideBarMini: false,
}

const changeState = (state = initialState, { type, ...rest }) => {
    switch (type) {
        case 'set':
            return { ...state, ...rest }
        default:
            return state
    }
}

const store = createStore(changeState)
export default store
